import { getDefaultRouteAfterLogin, isExplorerOnlyBlockedRoute } from "@/constants";
import { parse, stringify } from "qs";
import localCookies from "./cookie";
import { sanitizeRedirectUrl } from "./sanitize";

const resolvePostLoginRoute = (route: string, defaultUrl: string) => {
  const resolved = route || defaultUrl;
  return isExplorerOnlyBlockedRoute(resolved) ? getDefaultRouteAfterLogin() : resolved;
};

const AUTH_PARAMS_TO_REMOVE = ["code", "error", "error_description", "state"];

export const removeAuthParamsFromUrl = () => {
  if (typeof window === "undefined") return;

  const url = new URL(window.location.href);

  AUTH_PARAMS_TO_REMOVE.forEach((param) => {
    url.searchParams.delete(param);
  });

  const hash = url.hash.slice(1);
  if (hash) {
    const hashParams = parse(hash) as Record<string, string>;
    AUTH_PARAMS_TO_REMOVE.forEach((param) => delete hashParams[param]);
    const newHash = stringify(hashParams);
    url.hash = newHash ? `#${newHash}` : "";
  }

  window.history.replaceState(null, "", url.toString());
};

export let hasRedirected = false;

export const redirectOnce = (url: string) => {
  console.log("redirectOnce", url, hasRedirected);
  if (hasRedirected) {
    return;
  }
  hasRedirected = true;
  window.location.href = url;

  setTimeout(() => {
    hasRedirected = false;
  }, 500);
};

export const redirectUsingQuery = (defaultUrl = getDefaultRouteAfterLogin()) => {
  const parsed = parse(window.location.search?.slice(1));
  if (parsed.redirect && typeof parsed.redirect === "string") {
    return resolvePostLoginRoute(sanitizeRedirectUrl(parsed.redirect), defaultUrl);
  }

  const redirectRoute = localCookies.getItem("LOGIN_REDIRECT_ROUTE");
  const sanitized = redirectRoute ? sanitizeRedirectUrl(redirectRoute) : defaultUrl;
  return resolvePostLoginRoute(sanitized, defaultUrl);
};

window.addEventListener(
  "popstate",
  () => {
    hasRedirected = false;
  },
  false
);
